import { render, staticRenderFns, recyclableRender, components } from "./shopping-cart.vue?vue&type=template&id=78bf14d2&scoped=true&"
var renderjs
import script from "./shopping-cart.vue?vue&type=script&lang=js&"
export * from "./shopping-cart.vue?vue&type=script&lang=js&"
import style0 from "./shopping-cart.vue?vue&type=style&index=0&id=78bf14d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bf14d2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/shopping-cart/shopping-cart.vue"
export default component.exports